import AxiosClient from './AxiosClient';
import { handleError, handleSuccess, handlePaginatedData } from '../services/DataHelperFunctions';
import ApiUrl from '../services/APIUrl';
import { EUrlParams } from '../data/Constants';

import type {
  ISearchRequest,
  ICreateMultiNumericFeatureRequest,
  IUpdateMultiNumericFeatureRequest,
  IDeleteMultiNumericFeatureRequest,
} from '../../types/IRequestTypes';

export const FeatureApi = {
  //This method returns all multinumeric features from DB
  FetchMultiNumericFeature: (action: ISearchRequest) => {
    const params: Record<string, string | null> = {};

    if (action?.page) {
      params[EUrlParams.Page] = `${action.page}`;
    }

    if (action?.limit) {
      params[EUrlParams.Limit] = `${action.limit}`;
    }

    if (action?.searchCode) {
      params[EUrlParams.Search] = `${action.searchCode}`;
    }

    return AxiosClient.post(ApiUrl.ReadMultiNumericFeature, {}, { params })
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        if (err.response?.status === 404 || err.response?.status === 400) {
          return {
            data: [],
            searchKey: action.searchCode,
            currentPage: action.page,
            totalRecords: 0,
          };
        }
        return handleError(err);
      });
  },

  //This method creates the multinumeric feature
  CreateMultiNumericFeature: (action: { request: ICreateMultiNumericFeatureRequest }) => {
    return AxiosClient.post(ApiUrl.CreateMultiNumericFeature, action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(err);
      });
  },

  //This method updates the multinumeric feature
  UpdateMultiNumericFeature: (action: { request: IUpdateMultiNumericFeatureRequest }) => {
    return AxiosClient.post(ApiUrl.UpdateMultiNumericFeature, action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        handleError(err);
      });
  },

  //This method will delete the multinumeric feature
  DeleteMultiNumericFeature: (action: { request: IDeleteMultiNumericFeatureRequest[] }) => {
    return AxiosClient.post(ApiUrl.DeleteMultinumericFeature, action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(err);
      });
  },
};
